import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { store } from './store/store';
import theme from './theme';

import AdminLayout from './components/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ClaimsList from './pages/ClaimsList';
import ClaimView from './pages/ClaimView';
import ClaimEdit from './pages/ClaimEdit';
import ClaimEditAttachments from './pages/ClaimEditAttachments';
import Facilities from './pages/Facilities';
import Settings from './pages/Settings';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="claims" element={<ClaimsList />} />
              <Route path="claims/:id" element={<ClaimView />} />
              <Route path="claims/:id/edit" element={<ClaimEdit />} />
              <Route path="claims/:id/edit/attachments" element={<ClaimEditAttachments />} />
              <Route path="facilities" element={<Facilities />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </Router>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
